// extracted by mini-css-extract-plugin
export default {"pdfContainer":"pdf_pdfContainer__wtC6A","btn":"pdf_btn__l9Z84","loadingContainer":"pdf_loadingContainer__ej5xX"};